package br.com.htms.inspeccaocampo.shared.ui.components

import br.com.htms.inspeccaocampo.ui.kit.LinhaOpcoes
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import androidx.compose.material3.RadioButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.FotoAnexo
import br.com.htms.inspeccaocampo.data.RespostaSimNao
import br.com.htms.inspeccaocampo.data.SecaoSimNao

@Composable
fun CampoSimNaoCard(
    titulo: String,
    secao: SecaoSimNao,
    erro: String?,
    onResposta: (RespostaSimNao) -> Unit,
    onDescricao: (String) -> Unit,
    onTirarFoto: () -> Unit,
    onAdicionarMaisFoto: () -> Unit,
    onRemoverFoto: (FotoAnexo) -> Unit,
    descricaoLabel: String,
    exigirDescricaoSeSim: Boolean,
    exigirFotoSeSim: Boolean,
    onGaleria: (() -> Unit)? = null,
    modifier: Modifier = Modifier
) {
    var mostrarLista by remember { mutableStateOf(false) }

    Card(
        modifier = modifier.fillMaxWidth(),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface), border = PortalCores.BordaCartao
    ) {
        Column(
            modifier = Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Text(titulo, fontWeight = FontWeight.SemiBold, color = PortalCores.Navy)
            LinhaOpcoes(
                opcoes = RespostaSimNao.entries,
                selecionada = secao.resposta,
                rotulo = { it.rotulo },
                cor = { PortalCores.AzulIcone },
                onSelect = onResposta
            )
            if (secao.resposta == RespostaSimNao.SIM) {
                if (exigirDescricaoSeSim) {
                    AppOutlinedTextField(
                        value = secao.descricao,
                        onValueChange = onDescricao,
                        label = { Text(descricaoLabel) },
                        modifier = Modifier.fillMaxWidth(),
                        minLines = 2,
                        colors = FormFieldDefaults.textFieldColors(),
                        isError = erro != null
                    )
                }
                if (exigirFotoSeSim) {
                    CampoFotoRow(
                        label = "Câmera",
                        obrigatorio = true,
                        quantidadeFotos = secao.fotos.size,
                        onTirarFoto = onTirarFoto,
                        onAdicionarMais = onAdicionarMaisFoto,
                        onAbrirLista = { mostrarLista = true },
                        onGaleria = onGaleria
                    )
                }
            }
            erro?.let {
                Text(it, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall)
            }
        }
    }

    if (mostrarLista) {
        SharedFotosMenu(
            titulo = titulo,
            fotos = secao.fotos,
            aberto = true,
            onFechar = { mostrarLista = false },
            onRemover = onRemoverFoto
        )
    }
}
